import { render, staticRenderFns } from "./SysCategoryList.vue?vue&type=template&id=248eb8bf&scoped=true&"
import script from "./SysCategoryList.vue?vue&type=script&lang=js&"
export * from "./SysCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./SysCategoryList.vue?vue&type=style&index=0&id=248eb8bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248eb8bf",
  null
  
)

export default component.exports